import { ComboboxItem } from "@mantine/core";
import { repositoryPos } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../model/MessageResponse";

/** Danh sách kho bên Pancake để chọn ở cột "Kho Pancake" (value = id kho Pancake, lưu vào attribute6) */
export const getPancakeWarehouses = async (): Promise<ComboboxItem[]> => {
  const res = await repositoryPos.get<
    MessageResponse<{ id: string; name: string }[]>
  >(`/api/v1/TblDmInventory/get-pancake-warehouses`);
  if (res?.success) return res.data.map((x) => ({ value: x.id, label: x.name }));
  // Lỗi mạng/HTTP thì repository đã báo; còn lỗi cấu hình hoặc lỗi từ Pancake thì BE trả success = false
  if (res) NotificationExtension.Fails(res.message);
  return [];
};

/** Lưu kho Pancake (null = bỏ liên kết) cho một kho trong danh mục kho */
export const updateInventoryPancakeWarehouse = (
  inventoryId: string,
  pancakeWarehouseId: string | null,
) =>
  repositoryPos.post<MessageResponse<boolean>>(
    `/api/v1/TblDmInventory/update-attribute6`,
    { id: Number(inventoryId), attribute6: pancakeWarehouseId },
  );
